import React from "react";
import { Outlet } from "react-router-dom";

const AuthLayout = () => (
  <>
    <main className="w-full rounded-lg border border-gray-100">
      <section>
        <div className="mx-auto flex flex-col items-center justify-center px-6 py-8 min-h-screen">
          <div className="w-full rounded-lg bg-white shadow sm:max-w-md md:mt-0 xl:p-0">
            <div className="flex flex-col rounded-lg border border-gray-200 bg-white shadow-none">
              <div className="flex h-full flex-col justify-center gap-4 p-6">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </>
);

export default React.memo(AuthLayout);
